import React from 'react';
import { useTranslation } from 'react-i18next';
import { Comment, Typography } from '@perxis-auto/ui-kit';

import getCarDealerComment from '@/features/cars/helpers/getCarDealerComment';
import useCarData from '@/features/cars/hooks/useCarData';

import { DealerCommentProps } from './DealerComment.types';

import styles from './DealerComment.module.scss';

function DealerComment(props: DealerCommentProps) {
  const { t } = useTranslation();

  const { data } = useCarData();

  if (!data) {
    return null;
  }

  const dealerComment = getCarDealerComment(data);

  if (!dealerComment) {
    return null;
  }

  return (
    <div className={styles.dealerComment}>
      <Comment title={t('dealerComment.title')}>
        <Typography.Paragraph level="main" color="dark">
          {dealerComment}
        </Typography.Paragraph>
      </Comment>
    </div>
  );
}

export default DealerComment;
